import Storage from '@/helper/storage';
import { KEY_BFFSERVICE_APIKEY } from '@/helper/constants';
import http from '../../base/http';
import Config from '@/config';

interface TokenResponse {
  apiKey: string;
}

export const getApiKey = async (code?: string, appId?: string) => {
  if (code && appId) {
    const token = await requestApiKey(code, appId);
    setApiKey(token);
    return token;
  }

  // get from cache
  return Storage.getItem(KEY_BFFSERVICE_APIKEY);
};

export const setApiKey = (apiKey: string) => {
  Storage.setItem(KEY_BFFSERVICE_APIKEY, apiKey);
  return apiKey;
};

const requestApiKey = async (code: string, appId: string) => {
  const url = `${Config.BFF_SERVICE.URL}/hainan-bff/auth/api-key?code=${code}&appId=${appId}`;
  const response = await http.get<BFFResponse<TokenResponse>>(url);
  return response.data.apiKey;
};
